import axios from "axios";

export const getDashboardCardsReq = ({ admin_id, team_id, channel_id }) => {
  return axios.get(`/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/dashboard/cards`);
};

export const getDashboardTableReq = ({ admin_id, team_id, channel_id, params, signal }) => {
  return axios.get(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/dashboard/attendances`,
    { params, signal }
  );
};

export const getUserAttendanceReportReq = ({
  admin_id,
  team_id,
  channel_id,
  user_slack_id,
  body,
}) => {
  return axios.post(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/users/${user_slack_id}/reports`,
    body
  );
};

export const getLeaveRequestsReq = ({ admin_id, team_id, params }) => {
  return axios.get(`/admins/${admin_id}/teams/${team_id}/leaveRequests`, { params });
};

export const decideLeaveRequestReq = ({ admin_id, team_id, request_id, decision, reason }) => {
  return axios.post(`/admins/${admin_id}/teams/${team_id}/leaveRequests/${request_id}/decision`, {
    decision,
    reason,
  });
};

export const getUnresolvedCommentsReportReq = ({ admin_id, team_id, channel_id, body }) => {
  return axios.post(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/unresolved-comments`,
    body
  );
};

export const resolveAttendanceCommentReq = ({ admin_id, record_id, field, break_id }) => {
  return axios.put(`/admins/${admin_id}/attendance/${record_id}/resolve-comment`, {
    field,
    ...(break_id !== undefined && { break_id }),
  });
};

export const getUserLeaveAndWFHReportReq = ({
  admin_id,
  team_id,
  channel_id,
  user_slack_id,
  from,
  to,
}) => {
  return axios.get(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/users/${user_slack_id}/leaveAndWFHReport?from=${from}&to=${to}`
  );
};

export const getLeaveAndWFHDetails = ({
  admin_id,
  team_id,
  channel_id,
  user_slack_id,
  from,
  to,
  filter,
}) => {
  return axios.get(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/users/${user_slack_id}/leaveAndWFHDetails?from=${from}&to=${to}&filter=${filter}`
  );
};

export const getTravelAllowanceReportReq = ({ admin_id, team_id, channel_id, month, user_id }) => {
  const params = new URLSearchParams({ month, ...(user_id ? { user_id } : {}) });
  return axios.get(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/travelAllowanceReport?${params}`
  );
};

export const getUnapprovedAbsenceReportReq = ({
  admin_id,
  team_id,
  channel_id,
  month,
  user_id,
}) => {
  const params = new URLSearchParams({ month, ...(user_id ? { user_id } : {}) });
  return axios.get(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/unapprovedAbsenceReport?${params}`
  );
};

export const getUsersReq = ({ admin_id, team_id, channel_id }) => {
  return axios.get(`/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/users`);
};
export const notifyUserToCheckIn = ({ admin_id, user_id, channel_id, team_id, message }) => {
  return axios.post(
    `/admins/${admin_id}/teams/${team_id}/channels/${channel_id}/users/${user_id}/notifyToCheckIn`,
    { message }
  );
};
export const getPublicHolidaysReq = ({ admin_id }) => {
  return axios.get(`/admins/${admin_id}/public-holidays`);
};

export const createPublicHolidayReq = ({ admin_id, body }) => {
  return axios.post(`/admins/${admin_id}/public-holidays`, body);
};

export const updatePublicHolidayReq = ({ admin_id, id, body }) => {
  return axios.put(`/admins/${admin_id}/public-holidays/${id}`, body);
};

export const deletePublicHolidayReq = ({ admin_id, id }) => {
  return axios.delete(`/admins/${admin_id}/public-holidays/${id}`);
};

export const updateAttendanceDateTimeReq = async ({
  admin_id,
  record_id,
  field,
  timestamp,
  break_id,
}) => {
  return axios.put(`/admins/${admin_id}/attendance/${record_id}`, {
    field,
    timestamp,
    ...(break_id !== undefined && { break_id }),
  });
};

// ── Goals: Period Templates ──────────────────────────────────────────────────

export const listGoalTemplatesReq = ({ admin_id }) => {
  return axios.get(`/goals/${admin_id}/goal-templates`);
};

export const createGoalTemplateReq = ({ admin_id, body }) => {
  return axios.post(`/goals/${admin_id}/goal-templates`, body);
};

export const updateGoalTemplateReq = ({ admin_id, id, body }) => {
  return axios.put(`/goals/${admin_id}/goal-templates/${id}`, body);
};

export const archiveGoalTemplateReq = ({ admin_id, id }) => {
  return axios.delete(`/goals/${admin_id}/goal-templates/${id}`);
};

// ── Goals: Engineers Dashboard ───────────────────────────────────────────────

export const listGoalsEngineersReq = ({ admin_id, team_id, channel_id, params }) => {
  return axios.get(`/goals/${admin_id}/teams/${team_id}/channels/${channel_id}/goals/engineers`, {
    params,
  });
};

export const exportGoalsReq = ({ admin_id, team_id, channel_id, params }) => {
  return axios.get(`/goals/${admin_id}/teams/${team_id}/channels/${channel_id}/goals/export`, {
    params,
    responseType: "blob",
  });
};

// ── Goals: User Goal Periods ─────────────────────────────────────────────────

export const createUserGoalReq = ({ admin_id, team_id, channel_id, body }) => {
  return axios.post(`/goals/${admin_id}/teams/${team_id}/channels/${channel_id}/goals`, body);
};

export const getUserGoalReq = ({ admin_id, id }) => {
  return axios.get(`/goals/${admin_id}/goals/${id}`);
};

export const updateUserGoalReq = ({ admin_id, id, body }) => {
  return axios.put(`/goals/${admin_id}/goals/${id}`, body);
};

export const confirmUserGoalSetupReq = ({ admin_id, id }) => {
  return axios.post(`/goals/${admin_id}/goals/${id}/confirm-setup`);
};

export const markGoalItemReq = ({ admin_id, goal_item_id, body }) => {
  return axios.put(`/goals/${admin_id}/goal-items/${goal_item_id}`, body);
};

export const submitUserGoalReviewReq = ({ admin_id, id }) => {
  return axios.post(`/goals/${admin_id}/goals/${id}/submit-review`);
};

export const confirmUserGoalReviewReq = ({ admin_id, id }) => {
  return axios.post(`/goals/${admin_id}/goals/${id}/confirm-review`);
};

export const rejectUserGoalReviewReq = ({ admin_id, id, notes }) => {
  return axios.post(`/goals/${admin_id}/goals/${id}/reject-review`, { notes });
};

export const getUserGoalHistoryReq = ({ admin_id, user_channel_id }) => {
  return axios.get(`/goals/${admin_id}/user-channels/${user_channel_id}/goals/history`);
};

// ── User Management ──────────────────────────────────────────────────────────

export const listRolesReq = ({ admin_id }) => {
  return axios.get(`/admins/${admin_id}/roles`);
};

export const listAdminUsersReq = ({ admin_id }) => {
  return axios.get(`/admins/${admin_id}/admin-users`);
};

export const createAdminUserReq = ({ admin_id, body }) => {
  return axios.post(`/admins/${admin_id}/admin-users`, body);
};

export const updateAdminUserReq = ({ admin_id, id, body }) => {
  return axios.put(`/admins/${admin_id}/admin-users/${id}`, body);
};

export const archiveAdminUserReq = ({ admin_id, id }) => {
  return axios.delete(`/admins/${admin_id}/admin-users/${id}`);
};

export const changePasswordReq = ({ admin_id, body }) => {
  return axios.put(`/admins/${admin_id}/me/password`, body);
};

// ── Employees ────────────────────────────────────────────────────────────────

export const listEmployeesReq = ({ admin_id, team_id, channel_id }) => {
  return axios.get(`/admins/${admin_id}/employees`, { params: { team_id, channel_id } });
};

export const updateEmployeeReq = ({ admin_id, id, body }) => {
  return axios.put(`/admins/${admin_id}/employees/${id}`, body);
};

export const archiveEmployeeReq = ({ admin_id, id }) => {
  return axios.post(`/admins/${admin_id}/employees/${id}/archive`);
};

// ── Assets ───────────────────────────────────────────────────────────────────

export const listAssetsReq = ({ admin_id }) => {
  return axios.get(`/admins/${admin_id}/assets`);
};

export const listAssetAssigneesReq = ({ admin_id }) => {
  return axios.get(`/admins/${admin_id}/assets/assignees`);
};

export const createAssetReq = ({ admin_id, body }) => {
  return axios.post(`/admins/${admin_id}/assets`, body);
};

export const updateAssetReq = ({ admin_id, id, body }) => {
  return axios.put(`/admins/${admin_id}/assets/${id}`, body);
};

export const deleteAssetReq = ({ admin_id, id }) => {
  return axios.delete(`/admins/${admin_id}/assets/${id}`);
};

export const assignAssetReq = ({ admin_id, id, body }) => {
  return axios.post(`/admins/${admin_id}/assets/${id}/assign`, body);
};

export const returnAssetReq = ({ admin_id, id, body }) => {
  return axios.post(`/admins/${admin_id}/assets/${id}/return`, body);
};

export const disposeAssetReq = ({ admin_id, id, body }) => {
  return axios.post(`/admins/${admin_id}/assets/${id}/dispose`, body);
};

// ── Organizations ────────────────────────────────────────────────────────────

export const listOrganizationsReq = ({ admin_id }) => {
  return axios.get(`/admins/${admin_id}/organizations`);
};

export const createOrganizationReq = ({ admin_id, body }) => {
  return axios.post(`/admins/${admin_id}/organizations`, body);
};

export const updateOrganizationReq = ({ admin_id, id, body }) => {
  return axios.put(`/admins/${admin_id}/organizations/${id}`, body);
};

export const listOrganizationTeamsReq = ({ admin_id }) => {
  return axios.get(`/admins/${admin_id}/organization-teams`);
};

export const moveTeamReq = ({ admin_id, team_id, body }) => {
  return axios.put(`/admins/${admin_id}/organization-teams/${team_id}`, body);
};

// ── Roles ────────────────────────────────────────────────────────────────────

export const createRoleReq = ({ admin_id, body }) => {
  return axios.post(`/admins/${admin_id}/roles`, body);
};

export const updateRoleReq = ({ admin_id, id, body }) => {
  return axios.put(`/admins/${admin_id}/roles/${id}`, body);
};

export const deleteRoleReq = ({ admin_id, id }) => {
  return axios.delete(`/admins/${admin_id}/roles/${id}`);
};
